/**
 * Client-side Pendo initialization utility
 * Initializes Pendo when customer data becomes available
*/

/* eslint-disable no-console */

const PENDO_API_KEY = '7651abd8-9985-45df-6c3e-6a22f098834d';

let pendoInitialized = false;

const getCustomerDataFromCookie = () => {
  try {
    const thdCustomer = window?.THDCustomer?.default;

    if (!thdCustomer || !thdCustomer.isLoggedIn) {
      return null;
    }

    return {
      userId: thdCustomer.userID,
      svocId: thdCustomer.svocID,
      role: thdCustomer.role || thdCustomer.segment,
      isB2B: thdCustomer.isB2BCustomer
    };
  } catch (error) {
    console.warn('Failed to extract customer data from cookie:', error);
    return null;
  }
};

const loadPendoScript = () => {
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://cdn.pendo.io/agent/static/${PENDO_API_KEY}/pendo.js`;
  document.head.appendChild(script);

  // Initialize Pendo namespace
  window.pendo = window.pendo || {};
  window.pendo._q = window.pendo._q || [];

  const methods = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
  methods.forEach((method) => {
    window.pendo[method] = window.pendo[method] || function methodWrapper(...args) {
      const action = method === 'initialize' ? 'unshift' : 'push';
      window.pendo._q[action]([method, ...args]);
    };
  });
};

const initializePendo = (customerData) => {
  if (pendoInitialized) {
    return;
  }

  try {
    // Validate required data
    if (!customerData?.userId || !customerData?.svocId || !customerData?.role) {
      console.warn('Pendo initialization skipped: missing required data');
      return;
    }

    loadPendoScript();

    // Initialize Pendo
    window.pendo.initialize({
      visitor: {
        id: customerData.userId,
        thd_role: customerData.role,
        svoc_id: customerData.svocId
      },
      account: {
        id: customerData.svocId
      }
    });

    pendoInitialized = true;
    console.log('Pendo initialized successfully');
  } catch (error) {
    console.warn('Pendo initialization failed:', error);
  }
};

const watchForCustomerData = () => {
  // Check if customer data is available
  const customerData = getCustomerDataFromCookie();
  if (customerData?.isB2B) {
    initializePendo(customerData);
  }
};

export const initializeClientPendo = () => {
  if (typeof window === 'undefined') {
    return; // Server-side early return
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForCustomerData);
  } else {
    watchForCustomerData();
  }
};